import { ResourceItem } from './ResourceItem';
export class ResourceCollectionProcessor {
    processResults(response) {
        return (response.results ?? []).map(result => new ResourceItem(result));
    }
}
